import { Route } from '@angular/router';

export const matchStatisticsRoutes: Route[] = [
    {
        path: 'match/rating-details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/rating-statistics-details/rating-statistics-details.component').then(
                (c) => c.RatingStatisticsDetailsComponent
            ),
    },
    {
        path: 'match/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/match-statistics-details/match-statistics-details.component').then(
                (c) => c.MatchStatisticsDetailsComponent
            ),
    },
    {
        path: 'tournament/match/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/tournament-match-statistics-details/tournament-match-statistics-details.component').then(
                (c) => c.TournamentMatchStatisticsDetailsComponent
            ),
    },
    {
        path: 'local-tournament/match/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/local-tournament/local-tournament-match-statistics-details/local-tournament-match-statistics-details.component').then(
                (c) => c.LocalTournamentMatchStatisticsDetailsComponent
            ),
    },
    {
        path: 'match/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/match-statistics-games/match-statistics-games.component').then(
                (c) => c.MatchStatisticsGamesComponent
            ),
    },
    {
        path: 'tournament/list/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/tournament-match-statistics-list/tournament-match-statistics-list.component').then(
                (c) => c.TournamentMatchStatisticsListComponent
            ),
    },
    {
        path: 'local-tournament/list/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/local-tournament/local-tournament-match-statistics-list/local-tournament-match-statistics-list.component').then(
                (c) => c.LocalTournamentMatchStatisticsListComponent
            ),
    },
    {
        path: 'match/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/match-statistics-games-details/match-statistics-games-details.component').then(
                (c) => c.MatchStatisticsGamesDetailsComponent
            ),
    },
];
